import { render, staticRenderFns } from "./Fantasy3Dviewer.vue?vue&type=template&id=6333e9dc&"
import script from "./Fantasy3Dviewer.vue?vue&type=script&lang=js&"
export * from "./Fantasy3Dviewer.vue?vue&type=script&lang=js&"
import style0 from "./Fantasy3Dviewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBadge,VCol,VIcon,VRow,VSlider})
